import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import StripeCheckoutForm from './StripeCheckoutForm';
import './stripe-checkout.scss';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';
import getEnvName from '@bd-uikit-web/js-helpers/getEnvName';

console.log((getEnvName() === 'production') ? 'pk_live_8YPTwOAeydlQbXQKYSHVDAI6' : 'pk_test_CwFNQLF0fkyOp98BpMWd97hD');

export default ({ open, amount, currency, email, onToken }) => (

  <SimpleModal open={open} dismissable>
    <StripeProvider apiKey={getEnvName() === 'production'
      ? 'pk_live_8YPTwOAeydlQbXQKYSHVDAI6' : 'pk_test_CwFNQLF0fkyOp98BpMWd97hD'}>
      <Elements>
        <StripeCheckoutForm amount={amount} currency={currency} email={email} onToken={onToken} />
      </Elements>
    </StripeProvider>
  </SimpleModal>
);
